import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

async function createUserTransfer(payload) {
  const url = `${API_BASE}/UserTransfer/CreateTransfer`;

  const response = await apiFetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`CreateTransfer failed: HTTP ${response.status}`);
  }

  return await response.json().catch(() => null);
}

 async function actionTransfer(payload) {
    const url = `${process.env.REACT_APP_API_URL}/UserTransfer/UpdateDeviceGroup`;

    const res = await apiFetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const err = new Error(body?.message || `HTTP ${res.status}`);
      err.status = res.status;
      err.body = body;
      throw err;
    }

    return true;
  }

async function updateTransferRequest(visorId, type) {
  const url = `${API_BASE}/UserTransfer/UpdateTransfer?visorId=${encodeURIComponent(visorId)}&type=${encodeURIComponent(type)}`;

  const response = await apiFetch(url, {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`DeleteTransfer failed: HTTP ${response.status}`);
  }

  return await response.json().catch(() => null);
}

async function getAllTransfers(selectedSite) {
  const url = `${API_BASE}/UserTransfer/GetAllTransfers?groupId=${encodeURIComponent(
    selectedSite
  )}`;

  const response = await apiFetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`GetAllTransfers failed: HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

async function getActionedTransfers(selectedGroupId, interval) {
  const url = `${API_BASE}/UserTransfer/GetActionedTransfers?groupId=${encodeURIComponent(selectedGroupId)}&interval=${encodeURIComponent(interval)}`;

  const response = await apiFetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`GetActionedTransfers failed: HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

const UserTransferService = {
  createUserTransfer,
  updateTransferRequest: updateTransferRequest,
  getAllTransfers,
  getActionedTransfers,
  actionTransfer
};

export default UserTransferService;
